export const Features = Object.freeze({
    NewBorrowModal: 'NewBorrowModal',
    NewWalletConnect: 'NewWalletConnect',
});
